"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
var react_1 = __importStar(require("react"));
var index_styled_1 = require("./index.styled");
var Typo_1 = require("../Typo");
var icons_1 = require("../../icons");
var themes_1 = require("../../themes");
var mixins_1 = require("../../themes/mixins");
var ArrowLeft = icons_1.icons.ArrowLeft;
var white = themes_1.colors.white, greyColor100 = themes_1.colors.greyColor100, greyColor50 = themes_1.colors.greyColor50;
/**
 * @component Renders a Breadcrumbs component based on the provided links and invert flag.
 *
 * - The properties of the Breadcrumbs component.
 * @prop {Object} props - The properties of the Breadcrumbs component
 * @prop {BreadcrumbsProps} props.links - The array of links to be displayed in the breadcrumbs
 * @prop {boolean} props.invert - Flag to indicate whether to invert the colors of the breadcrumbs
 * @return {React.ReactElement} The rendered Breadcrumbs component
 */
var Breadcrumbs = function (_a) {
    var links = _a.links, invert = _a.invert;
    var _b = (0, react_1.useState)(0), containerWidth = _b[0], setContainerWidth = _b[1];
    var _c = (0, react_1.useState)(false), beConcise = _c[0], setBeConcise = _c[1];
    var measuredContainer = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        measuredContainer.current && setContainerWidth(measuredContainer.current.offsetWidth);
    }, []);
    (0, react_1.useLayoutEffect)(function () {
        var _a;
        if (containerWidth === 0)
            return; // when the measuredRef isn't updated yet
        var children = (_a = measuredContainer.current) === null || _a === void 0 ? void 0 : _a.children;
        var isOverflowing = children[children.length - 1].getBoundingClientRect().right > containerWidth * 0.95; // if exceeds 95% of the parent
        if (isOverflowing)
            setBeConcise(true);
    }, [containerWidth]);
    if (containerWidth > (0, mixins_1.getBreakPoint)('md')) {
        // for large devices (not default since containerWidth is initialized to 0)
        var linksDisplayed_1 = beConcise && links.length > 3 ? [links[0], { to: "", display: "..." }, links[links.length - 2], links[links.length - 1]] : links;
        return (react_1.default.createElement(index_styled_1.StyledBreadcrumbs, { ref: measuredContainer }, linksDisplayed_1.map(function (link, ind) {
            return (react_1.default.createElement(index_styled_1.StyledLinkCrumb, { to: link.to, invert: invert, key: ind, style: ind === linksDisplayed_1.length - 1
                    ? {
                        pointerEvents: 'none',
                        color: greyColor50,
                        width: !beConcise
                            ? 'auto'
                            : (function () {
                                var _a;
                                var children = (_a = measuredContainer.current) === null || _a === void 0 ? void 0 : _a.children;
                                var childrenCount = children.length;
                                var correctionFactor = 88;
                                return containerWidth - (children[0].scrollWidth + correctionFactor + (childrenCount > 2 && children[childrenCount - 2].scrollWidth)) + 'px';
                            })(),
                    }
                    : {} },
                react_1.default.createElement(Typo_1.SANS_2, { style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } }, link.display)));
        })));
    }
    return (react_1.default.createElement(index_styled_1.StyledBreadcrumbs, { ref: measuredContainer },
        react_1.default.createElement(index_styled_1.StyledLinkCrumb, { to: (links[links.length - 2] || links[0]).to, invert: invert },
            react_1.default.createElement(ArrowLeft, { size: 14, weight: "bold", color: invert ? white : greyColor100 }),
            react_1.default.createElement(Typo_1.SANS_2, { invert: invert }, "Back"))));
};
exports.Breadcrumbs = Breadcrumbs;
